import ErrorGif from '../../images/common/visitPageNotFound.json';
import { Player } from '@lottiefiles/react-lottie-player';
import React from 'react';
import { useHistory } from 'react-router-dom';

const NotFoundPage = () => {
  const history = useHistory();
  const backToHome = () => {
    history.push('/home');
  };

  return (
    <div className="container" style={{ background: '#ffffff' }}>
      <div className="h-4/5 flex flex-col justify-center items-center">
        <Player
          autoplay
          loop
          src={ErrorGif}
          style={{ height: '220px', width: '300px' }}
        ></Player>
        <h5 className="">
          <span className="font-bold m-2 p-2" style={{ color: '#3A2CA0' }}>
            Page Not Found
          </span>
        </h5>
        <p
          className="flex flex-col text-justify m-2 p-2 text-center"
          style={{ color: '#585969' }}
        >
          We looked everywhere for this page. <br />
          Are you sure you entered the right URL?
        </p>
      </div>
      <div className="h-1/5 flex flex-row justify-center items-center">
        <button
          onClick={backToHome}
          className="rounded-12 pt-12px pb-10px center w-4/5"
          style={{ 'background-color': '#ffbb00' }}
        >
          <span className="text-button-s font-bold text-textbox mr-10px">
            Return to Home
          </span>
        </button>
      </div>
    </div>
  );
};

export default NotFoundPage;
